<template>
  <div class="case-base-page col-block width-full">
    <template v-if="layoutBlocks.includes('form')">
      <div class="form-container col-block width-full">
        <div v-if="(['create'].includes(mode) && ['supervisor', 'manager'].includes(user.role)) || (['edit'].includes(mode) && ['supervisor'].includes(user.role))" class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="{
              'create': 6,
              'edit': 4
            }[this.mode]"
            :alerts="alerts"
            :forms="formOptions['field0']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field0', result, validate, errors)"
          >
            <template slot="USER_ID" slot-scope="props">
              <div :name="props" class="input-group" :style="{ width: '100%', padding: 0 }">
                <inputTag
                  :style="{
                    width: '100%'
                  }"
                  :inputStyle="{
                    'padding-right': '40px'
                  }"
                  :init="(userOptions.find(option => option.value === result['case'].user_id) || {}).title"
                  :emptyDisplay="true"
                  :disabled="false"
                  :placeholder="'all'"
                  :tags="users"
                  :prefix="'(?:^)'"
                  :target="'^(.*?)$'"
                  :replace="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                  :filter="content => user => content && ([user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i'))"
                  :tagDisplay="user => [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')"
                  @send="content => onEvent('send', content)"
                  @tag="content => onEvent('tag', content)"
                ></inputTag>
              </div>
            </template>
          </customForm>
        </div>
        <div class="form-block col-block width-full">
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="{
              'create': 6,
              'edit': 4,
              'analysis': 6
            }[this.mode]"
            :alerts="alerts"
            :forms="formOptions['field1']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field1', result, validate, errors)"
          >
            <template slot="AFFECTED" slot-scope="props">
              <div v-if="props.form.type === 'custom'" class="AFFECTED-block row-block flex-start" :name="props">
                <div class="AFFECTED-title">{{ 'Affected'/* ___ */ }}</div>
                <switchButton
                  :disabled="false"
                  :checked="caseData.affected"
                  @input="c => result['case'].affected = c"
                ></switchButton>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </customForm>
        </div>
      </div>
    </template>
    <template v-if="layoutBlocks.includes('analysis')">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="analysis-container col-block width-full">
        <div class="analysis-block col-block width-full">
          <customForm
            :init="analysisData"
            :layoutType="'grid'"
            :groupCount="6"
            :alerts="alerts"
            :forms="formOptions['field2']"
            :scope="'test'"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('analysis', 'field2', result, validate, errors)"
          >
            <template slot="REPORT_PHENOVARDB" slot-scope="props">
              <div class="REPORT_PHENOVARDB-block row-block flex-start" :name="props">
                <div class="REPORT_PHENOVARDB-title">{{ 'Off'/* ___ */ }}</div>
                <switchButton
                  :disabled="!reportDatabaseable"
                  :checked="analysisData.report_phenovardb"
                  :customStyle="{
                    cursor: 'pointer'
                  }"
                  @click="e => !reportDatabaseable && addToast('error', 'At least one card should be left open.'/* ___ */)"
                  @input="c => result['analysis'].report_phenovardb = c"
                ></switchButton>
                <div class="REPORT_PHENOVARDB-title active">{{ 'On'/* ___ */ }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </template>
          </customForm>
          <slot v-if="isUpdate" :name="'analysis-update'" :data="sendData"></slot>
        </div>
        <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
        <div class="analysis-block col-block width-full">
          <slot :name="'analysis-import'" :data="sendData"></slot>
          <div class="analysis-title-container row-block">
            <div class="analysis-title main">{{ 'Phenotype prioritization'/* ___ */ }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="phenotype-panel-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.phenotypePanel }" @click="e => display.phenotypePanel = !display.phenotypePanel">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ 'Phenotype Panel'/* ___ */ }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.phenotypePanel" class="phenotype-panel-block block-content col-block width-full">
                <div :style="{ height: '10px' }"></div>
                <template v-if="phenotypePanels.length">
                  <div class="panel-group col-block flex-start" v-for="(panel, pindex) in phenotypePanels" :key="pindex">
                    <div
                      class="item-container row-block"
                      @click="e => {
                        selectedPhenotypes['panelPhenotypes'] =
                          selectedPhenotypes['panelPhenotypes'].some(phenotype => phenotype.panel.id === panel.id) ? selectedPhenotypes['panelPhenotypes'].filter(p => p.panel.id !== panel.id)
                          : selectedPhenotypes['panelPhenotypes'].filter(p => p.panel.id !== panel.id).concat(panel.phenotypes)
                      }"
                    >
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['panelPhenotypes'].filter(phenotype => phenotype.panel.id === panel.id).length === panel.phenotypes.length ? require('../../assets/images/checkbox-true.svg')
                          : selectedPhenotypes['panelPhenotypes'].some(phenotype => phenotype.panel.id === panel.id) ? require('../../assets/images/checkbox-minus.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title main">{{ panel.panel }}</div>
                    </div>
                    <div class="panel-item-container row-block flex-wrap">
                      <div
                        class="item-container row-block"
                        v-for="(phenotype, phindex) in panel.phenotypes"
                        :key="phindex"
                        @click="e => {
                          selectedPhenotypes['panelPhenotypes'] =
                            selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? selectedPhenotypes['panelPhenotypes'].filter(p => (p.panel.id + '_' + p.id) !== (phenotype.panel.id + '_' + phenotype.id))
                            : selectedPhenotypes['panelPhenotypes'].concat([phenotype])
                        }"
                      >
                        <img
                          class="checkbox"
                          :src="
                            selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? require('../../assets/images/checkbox-true.svg')
                            : require('../../assets/images/checkbox-false.svg')
                          "
                        >
                        <div class="item-title">{{ phenotype.query }}</div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="row-block" :style="{ width: '100%' }">
                    <router-link class="link dark" :to="{ name: 'panel' }">{{ 'You don\'t have any panel yet. you can create a panel here'/* ___ */ }}</router-link>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="search-container row-block">
            <div class="search-block col-block" :style="{ flex: 1 }">
              <div class="row-block" :style="{ width: '100%' }">
                <div class="search-input input-group" :style="{ flex: 1 }">
                  <phenotypeTag
                    :style="{
                      width: '100%'
                    }"
                    :placeholder="'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'/* ___ */"
                    :init="tagData.query['phenotype']"
                    :dataInfo="tagData.tag['phenotypes'].info"
                    :phenotypes="tagData.tag['phenotypes'].datas"
                    @input="content => { tagData.query['phenotype'] = content; getPhenotypes(content); customValidate([], ['selected', 'genePanel']) }"
                    @tag="content => { tagData.query['phenotype'] = content; customValidate([], ['selected', 'genePanel']) }"
                    @send="content => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch('phenotype', tagData.query['phenotype']) : ''"
                  ></phenotypeTag>
                  <img :src="require('../../assets/images/search-solid.svg')" alt="">
                </div>
                <div :style="{ width: '22px' }"></div>
                <button class="main-button circle-button" :disabled="!((tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'])" @click="e => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch('phenotype', tagData.query['phenotype']) : ''">
                  <span>{{ 'Add'/* ___ */ }}</span>
                </button>
              </div>
              <div v-if="searchedPhenotypes['phenotypes'].length" class="selected-container col-block flex-start">
                <div class="selected-title-container row-block">
                  <div class="selected-title">{{ 'Selected'/* ___ */ }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="selected-item-container row-block flex-wrap">
                  <div
                    class="item-container row-block"
                    v-for="(phenotype, phindex) in searchedPhenotypes['phenotypes']"
                    :key="phindex"
                    :class="{
                      disabled: selectedLimit['phenotypes'] && !selectedPhenotypes['phenotypes'].includes(phenotype)
                    }"
                    @click="e => {
                      selectedPhenotypes['phenotypes'] =
                        e.currentTarget.className.split(' ').includes('disabled') ? selectedPhenotypes['phenotypes']
                        : selectedPhenotypes['phenotypes'].includes(phenotype) ? selectedPhenotypes['phenotypes'].filter(p => p.id !== phenotype.id)
                        : selectedPhenotypes['phenotypes'].concat([phenotype])
                    }"
                  >
                    <div class="item-block row-block">
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['phenotypes'].includes(phenotype) ? require('../../assets/images/checkbox-true.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title">{{ phenotype.query }}</div>
                    </div>
                    <img class="option" :src="require('../../assets/images/add-to-panel-icon.svg')" alt="" @click="e => addToPanel(phenotype)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0px' }">
          <div class="analysis-title-container row-block">
            <div class="analysis-title">{{ 'Gene filter'/* ___ */ }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="search-container row-block">
            <div class="search-block col-block" :style="{ flex: 1 }">
              <div class="row-block" :style="{ width: '100%' }">
                <div class="search-input input-group" :style="{ flex: 1 }">
                  <geneTag
                    :style="{
                      width: '100%'
                    }"
                    :tagHeight="'300px'"
                    :placeholder="'Gene Panel (eg: Additional findings health related)'/* ___ */"
                    :init="tagData.query['gene']"
                    :dataInfo="tagData.tag['genes'].info"
                    :genes="tagData.tag['genes'].datas"
                    @input="content => { tagData.query['gene'] = content; getGenes(content); customValidate([], ['selected', 'genePanel']) }"
                    @tag="content => { tagData.query['gene'] = content.name; tagData.curTag['gene'] = content; customValidate([], ['selected', 'genePanel']) }"
                    @send="content => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch('gene', tagData.curTag['gene'] || tagData.query['gene']) : ''"
                  ></geneTag>
                  <img :src="require('../../assets/images/search-solid.svg')" alt="">
                </div>
                <div :style="{ width: '22px' }"></div>
                <button class="main-button circle-button" :class="{ loading: loading['addToSearch'] }" :disabled="!((tagData.tag['genes'].datas || []).length && tagData.query['gene'])" @click="e => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch('gene', tagData.curTag['gene'] || tagData.query['gene']) : ''">
                  <span>{{ 'Add'/* ___ */ }}</span>
                </button>
                <div :style="{ width: '6px' }"></div>
                <div class="icon-block" :style="{ '--size': '40px' }" @click="e => openGenePanelSearch()">
                  <img :src="require('../../assets/images/gene-panel-icon.svg')" alt="">
                </div>
              </div>
              <div v-if="searchedPhenotypes['genes'].length" class="selected-container col-block flex-start">
                <div class="selected-title-container row-block">
                  <div class="selected-title">{{ 'Selected'/* ___ */ }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="selected-item-container row-block flex-wrap">
                  <div
                    class="item-container row-block"
                    v-for="(gene, gindex) in searchedPhenotypes['genes']"
                    :key="gindex"
                    :class="{
                      disabled: selectedLimit['genes'] && !selectedPhenotypes['genes'].includes(gene)
                    }"
                    @click="e => {
                      selectedPhenotypes['genes'] =
                        e.currentTarget.className.split(' ').includes('disabled') ? selectedPhenotypes['genes']
                        : selectedPhenotypes['genes'].includes(gene) ? selectedPhenotypes['genes'].filter(g => g.name + '_' + g.id !== gene.name + '_' + gene.id)
                        : selectedPhenotypes['genes'].concat([gene])
                    }"
                  >
                    <div class="item-block row-block">
                      <img
                        class="checkbox"
                        :src="
                          selectedPhenotypes['genes'].includes(gene) ? require('../../assets/images/checkbox-true.svg')
                          : require('../../assets/images/checkbox-false.svg')
                        "
                      >
                      <div class="item-title">{{ gene.name }}</div>
                    </div>
                    <img class="option" :src="require('../../assets/images/gene-panel-white-icon.svg')" alt="" @click="e => openGenePanelDataSelect(gene)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="allele-frequency-threshold-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.alleleFrequencyThreshold }" @click="e => display.alleleFrequencyThreshold = !display.alleleFrequencyThreshold">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ 'Allele frequency threshold for inheritance modes'/* ___ */ }}</div>
                <borCor
                  :width="'300px'"
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :blockStyle="{
                    padding: '10px'
                  }"
                >
                  <div slot="trigger">
                    <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                  </div>
                  <div slot="content">
                    <div>{{ 'The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1.'/* ___ */ }}</div>
                  </div>
                </borCor>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.alleleFrequencyThreshold" class="allele-frequency-threshold-block block-content col-block">
                <div :style="{ height: '15px' }"></div>
                <customForm
                  :init="analysisData"
                  :layoutType="'grid'"
                  :groupCount="6"
                  :alerts="alerts"
                  :forms="formOptions['field3_1']"
                  :scope="scope"
                  :reading="false"
                  @change="(result, validate, errors) => formOnChange('analysis', 'field3_1', result, validate, errors)"
                ></customForm>
              </div>
            </div>
          </div>
          <div class="score-threshold-container block col-block">
            <div class="block-content">
              <div class="display-icon center-block" :class="{ active: display.scoreThreshold }" @click="e => display.scoreThreshold = !display.scoreThreshold">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="">
              </div>
              <div class="block-title-container row-block">
                <div class="block-title">{{ 'Score threshold for phenotype/gene panel selection'/* ___ */ }}</div>
                <borCor
                  :width="'300px'"
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :blockStyle="{
                    padding: '10px'
                  }"
                >
                  <div slot="trigger">
                    <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                  </div>
                  <div slot="content">
                    <div>{{ 'Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. The value should be ≥ 0.6 and ≤ 1'/* ___ */ }}</div>
                  </div>
                </borCor>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div v-show="display.scoreThreshold" class="score-threshold-block block-content col-block">
                <div :style="{ height: '15px' }"></div>
                <customForm
                  :init="analysisData"
                  :layoutType="'grid'"
                  :groupCount="6"
                  :alerts="alerts"
                  :forms="formOptions['field3_2']"
                  :scope="scope"
                  :reading="false"
                  @change="(result, validate, errors) => formOnChange('analysis', 'field3_2', result, validate, errors)"
                ></customForm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="layoutBlocks.includes('file')">
      <hr class="custom full" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
      <div class="file-container col-block width-full">
        <div class="file-title row-block">
          <div class="title row-block">
            <b>{{ { 'vcf': 'VCF', 'fastq': 'FASTQ' }[dataset] + ' Dataset'/* ___ */ }}</b>
            <div :style="{ width: '10px' }"></div>
            <div>{{ '( If you don\'t have data yet, you can upload later.)'/* ___ */ }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <template v-if="['supervisor'].includes(user.role) && ['fastq'].includes(dataset)">
            <div :style="{ width: '20px' }"></div>
            <div class="file-cloud-container row-block">
              <div class="file-cloud-title">{{ 'Upload from google bucket'/* ___ */ }}</div>
              <div :style="{ width: '20px' }"></div>
              <switchButton
                :disabled="false"
                :checked="fromCloud"
                @input="c => { fromCloud = c; initFile(); }"
              ></switchButton>
            </div>
          </template>
          <div :style="{ flex: 1 }"></div>
          <div class="other row-block">
            <div :style="{ flex: 1 }"></div>
            <button v-if="dataset === 'fastq'" class="white-gray-button circle-button center-block" :disabled="Object.values(fileSets[fileSets.length - 1]).some(file => !file)" @click="e => fileSets.push({ r1: null, r2: null })">
              <img :src="require('../../assets/images/plus-solid.svg')" alt="">
            </button>
            <div v-else></div>
          </div>
        </div>
        <template v-if="dataset === 'fastq'">
          <div :style="{ height: '4px' }"></div>
          <customForm
            :init="caseData"
            :layoutType="'grid'"
            :groupCount="6"
            :alerts="alerts"
            :forms="formOptions['field4']"
            :scope="scope"
            :reading="false"
            @change="(result, validate, errors) => formOnChange('case', 'field4', result, validate, errors)"
          ></customForm>
        </template>
        <div v-show="dataset === 'vcf'" class="file-content">
          <div :style="{ height: '15px' }"></div>
          <div class="file-set-group row-block stretch" v-for="(set, index) in vcfSets" :key="index">
            <div class="file-block col-block" :style="{ flex: 1 }">
              <div class="title">{{ 'VCF file'/* ___ */ }}</div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.vcf">
                <div class="source">{{ set.vcf.name }}</div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role) || userSetting.allow_upload_vcf">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_vcf'" extension="vcf,gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'vcf'), () => addToast('error', 'Please upload vcf file'/* ___ */))">
                  <label :for="'set' + (index + 1) + '_vcf'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ 'Select'/* ___ */ }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'vcf')">
                  <span>{{ 'Select'/* ___ */ }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', 'You have no permission to upload the file.'/* ___ */)">
                <span>{{ 'Select'/* ___ */ }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="file-block col-block alert" :style="{ flex: 1 }">
              <div class="title">{{ 'Important Notice !'/* ___ */ }}</div>
              <div :style="{ height: '10px' }"></div>
              <div
                class="source"
                v-html="[
                  'Currently, we only support genome build version GRCh38/hg38.',
                  'Please make sure a concordant genome build version of vcf file is uploaded.'
                ].join('<br>')"
              ></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
        <div v-show="dataset === 'fastq'" class="file-content">
          <div :style="{ height: '15px' }"></div>
          <div class="file-set-group row-block stretch" v-for="(set, index) in fileSets" :key="index">
            <div class="file-block col-block" :style="{ flex: 1 }">
              <div class="title">{{ 'Set' + (index + 1) + '-Fastq-R1'/* ___ */ }}</div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.r1">
                <div class="source">{{ set.r1.name }}</div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role)">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_r1'" extension="fq,gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'r1'), () => addToast('error', 'Please upload fq or gz file'/* ___ */))">
                  <label :for="'set' + (index + 1) + '_r1'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ 'Select'/* ___ */ }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'r1')">
                  <span>{{ 'Select'/* ___ */ }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', 'You have no permission to upload the file.'/* ___ */)">
                <span>{{ 'Select'/* ___ */ }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="file-block col-block" :style="{ flex: 1 }">
              <div class="title">{{ 'Set' + (index + 1) + '-Fastq-R2'/* ___ */ }}</div>
              <div :style="{ height: '10px' }"></div>
              <template v-if="set.r2">
                <div class="source">{{ set.r2.name }}</div>
                <div :style="{ height: '10px' }"></div>
              </template>
              <template v-if="['manager', 'supervisor'].includes(user.role)">
                <div v-if="!fromCloud" class="mask">
                  <input v-show="false" type="file" :id="'set' + (index + 1) + '_r2'" extension="fq,gz" @change="e => fileTypeCheck(e, e => selectFile(e, set, 'r2'), () => addToast('error', 'Please upload fq or gz file'/* ___ */))">
                  <label :for="'set' + (index + 1) + '_r2'"></label>
                  <button class="white-gray-button circle-button">
                    <span>{{ 'Select'/* ___ */ }}</span>
                  </button>
                </div>
                <button v-else class="white-gray-button circle-button" @click="e => openFileCloud(set, 'r2')">
                  <span>{{ 'Select'/* ___ */ }}</span>
                </button>
              </template>
              <button v-else class="white-gray-button circle-button" @click="e => addToast('error', 'You have no permission to upload the file.'/* ___ */)">
                <span>{{ 'Select'/* ___ */ }}</span>
              </button>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- emit -->
    <span v-show="false">{{ onError }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  getCloudFilePaths,
  getGenePanel,
  getGenePanelCondition,
  getGenePanelDivisions,
  getGenePanelHpo,
  getGenePanels,
  getGenePanelSymbol,
  getManagedUsers,
  getOmicss,
  getPhenotypePanels,
  getSearchGeneEntry,
  getSearchPhenotype,
  putUserSettings
} from '../../api'
import customForm from '../../components/tool/customForm'
import switchButton from '../../components/tool/switchButton'
import borCor from '../../components/tool/newBorCor.vue'
import inputTag from '../../components/tool/inputTag'
import phenotypeTag from '../../components/tool/phenotypeTag'
import geneTag from '../../components/tool/geneTag'
import routeLoading from '../../mixins/routeLoading.vue'
import { priceMap } from '../../constants/global/data'
import { groupBy, fileTypeCheck, dateFormat } from '../../constants/global/util'

export default {
  components: {
    customForm,
    switchButton,
    borCor,
    inputTag,
    phenotypeTag,
    geneTag
  },
  mixins: [
    routeLoading
  ],
  props: {
    mode: {
      type: String,
      required: true
    },
    isUpdate: {
      type: Boolean,
      default: () => false
    },
    layoutBlocks: {
      type: Array,
      default: () => [
        'form',
        'analysis',
        'file'
      ]
    },
    dataset: {
      type: String,
      default: () => ''
    },
    scope: {
      type: String,
      default: () => ''
    },
    defaultData: {
      type: Object,
      required: true
    },
    projects: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // form
      caseData: {},
      analysisData: {
        report_phenovardb: true
      },
      alerts: {},
      result: {
        'case': {},
        'analysis': {},
        'view': {}
      },
      validate: {},
      error: {},
      onSubmit: false,
      // options
      users: [],
      genePanels: [],
      divisions: [],
      omicss: {},
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // phenotype
      phenotypePanels: [],
      searchedPhenotypes: {
        phenotypes: [],
        genes: []
      },
      selectedPhenotypes: {
        panelPhenotypes: [],
        phenotypes: [],
        genes: []
      },
      // file
      fromCloud: false,
      cloudFilePaths: [],
      cloudFileCurrentPath: null,
      vcfSets: [
        {
          vcf: null
        }
      ],
      fileSets: [
        {
          r1: null,
          r2: null
        }
      ],
      // display
      display: {
        phenotypePanel: false,
        alleleFrequencyThreshold: false,
        scoreThreshold: false
      },
      // loading
      loading: {
        addToSearch: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'modal',
      'userSetting'
    ]),
    onError () {
      let result = Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
      this.$emit('onError', result)
      return result
    },
    selectedLimit () {
      return {
        phenotypes: Object.values(this.sendData.project.phenotypes || {}).filter(x => x).reduce((s, c) => s + c.length, 0) >= 30,
        genes: (this.sendData.project.gene_panels || []).length >= 10
      }
    },
    reportDatabaseable () {
      return (
        !['analysis'].includes(this.mode) ||
        !this.result['analysis'].report_phenovardb ||
        this.projects.filter(project => this.analysisData.id === project.id ? this.result['analysis'].report_phenovardb : project.report_phenovardb).length > 1
      )
    },
    // options
    userOptions () {
      return this.users.map(user => ({ title: [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : ''), value: user.id }))
    },
    sexOptions () {
      return [
        { title: 'Male'/* ___ */, value: 'Male' },
        { title: 'Female'/* ___ */, value: 'Female' },
        { title: 'Unknown'/* ___ */, value: 'Unknown' }
      ]
    },
    populationOptions () {
      return [
        { title: 'African/African-American'/* ___ */, value: 'African/African-American' },
        { title: 'Latino/Admixed American'/* ___ */, value: 'Latino/Admixed American' },
        { title: 'Ashkenazi Jewish'/* ___ */, value: 'Ashkenazi Jewish' },
        { title: 'East Asian'/* ___ */, value: 'East Asian' },
        { title: 'Koreans'/* ___ */, value: 'Koreans' },
        { title: 'Japanese'/* ___ */, value: 'Japanese' },
        { title: 'Other East Asian'/* ___ */, value: 'Other East Asian' },
        { title: 'Finnish'/* ___ */, value: 'Finnish' },
        { title: 'Non-Finnish European'/* ___ */, value: 'Non-Finnish European' },
        { title: 'Bulgarian'/* ___ */, value: 'Bulgarian' },
        { title: 'Estonian'/* ___ */, value: 'Estonian' },
        { title: 'North-Western European'/* ___ */, value: 'North-Western European' },
        { title: 'Southern European'/* ___ */, value: 'Southern European' },
        { title: 'Swedish'/* ___ */, value: 'Swedish' },
        { title: 'Other non-Finnish European'/* ___ */, value: 'Other non-Finnish European' },
        { title: 'South Asian'/* ___ */, value: 'South Asian' },
        { title: 'Other'/* ___ */, value: 'Other' }
      ]
    },
    omicsOptions () {
      return Object.keys(this.omicss.omics || {}).map(key => ({ title: key, value: key }))
    },
    pipelineOptions () {
      let curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {}
      return Object.keys(curOmics.pipeline || {}).map(key => ({ title: key, value: key }))
    },
    libraryTypeOptions () {
      let curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {}
      let curPipeline = (curOmics.pipeline || {})[this.result['case'].pipeline_name] || {}
      return (curPipeline.library_type || []).map(key => ({ title: key, value: key }))
    },
    // static
    formOptions () {
      return {
        'field0': [
          {
            title: 'Owner'/* ___ */,
            value: 'USER_ID',
            type: 'custom',
            grid: {
              'create': 3,
              'edit': 4
            }[this.mode],
            disabled: () => false,
            validate: 'required'
          }
        ],
        'field1': [
          {
            title: 'Case ID'/* ___ */,
            value: 'case_id',
            type: {
              'create': 'input',
              'edit': 'input',
              'analysis': 'text'
            }[this.mode],
            grid: 2,
            wrap: true,
            disabled: () => false,
            placeholder: () => 'Case ID'/* ___ */,
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode]
          },
          {
            title: 'Sample type'/* ___ */,
            value: 'AFFECTED',
            type: {
              'create': 'custom',
              'edit': 'custom',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            style: {
              'true': { color: '#83C91E' },
              'false': { color: '#999999' }
            }[this.caseData.affected + ''],
            disabled: () => false,
            inputFormat: () => ({
              'true': 'Affected'/* ___ */,
              'false': 'Unaffected'/* ___ */
            }[this.caseData.affected + ''])
          },
          {
            title: 'Name'/* ___ */,
            value: 'subject_name',
            type: {
              'create': 'input',
              'edit': 'input',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            disabled: () => false,
            placeholder: () => 'John'/* ___ */
          },
          {
            title: 'Sex'/* ___ */,
            value: 'sex',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            options: this.sexOptions,
            style: {
              Male: { color: '#003679' },
              Female: { color: '#FA3D3D' },
              Unknown: { color: '#333333' }
            }[this.result['case'].sex],
            disabled: () => false,
            placeholder: () => 'Sex'/* ___ */,
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode]
          },
          {
            title: 'Year of Birth'/* ___ */,
            value: 'birth_year',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 1,
            wrap: true,
            options: [{ title: 'Unknown'/* ___ */, value: 'Unknown' }, ...(new Array((new Date()).getYear() + 1)).fill('').map((_, i) => ({ title: i + 1900, value: i + 1900 })).reverse()],
            disabled: () => false,
            placeholder: () => 'Year'/* ___ */,
            validate: {
              'create': 'required',
              'edit': 'required',
              'analysis': ''
            }[this.mode],
            inputFormat: value => value || 'Unknown',
            outputFormat: value => (value && value !== 'Unknown') ? value : undefined
          },
          {
            title: 'Population'/* ___ */,
            value: 'population',
            type: {
              'create': 'select',
              'edit': 'select',
              'analysis': 'text'
            }[this.mode],
            grid: 2,
            wrap: true,
            options: this.populationOptions,
            disabled: () => false,
            placeholder: () => 'Population'/* ___ */
          },
          {
            title: 'Note'/* ___ */,
            value: 'note',
            type: {
              'create': 'textarea',
              'edit': 'textarea',
              'analysis': 'text'
            }[this.mode],
            grid: 4,
            row: 4,
            wrap: true,
            disabled: () => false,
            placeholder: () => 'Ex: Compassbioinfomatics. Inc'/* ___ */,
            validate: 'max:900'
          }
        ],
        'field2': [
          {
            title: 'Analysis Name'/* ___ */,
            value: 'name',
            type: 'input',
            grid: 2,
            disabled: () => false,
            placeholder: () => 'breast cancer panel'/* ___ */,
            validate: 'required'
          },
          {
            title: 'Analysis Note'/* ___ */,
            value: 'note',
            type: 'textarea',
            grid: 3,
            row: 4,
            wrap: true,
            disabled: () => false,
            placeholder: () => 'Ex: Compassbioinfomatics. Inc'/* ___ */,
            validate: 'max:300'
          },
          {
            title: 'Report to PhenoVarDB'/* ___ */,
            value: 'REPORT_PHENOVARDB',
            type: 'custom',
            grid: 1,
            disabled: () => false
          }
        ],
        'field3_1': [
          {
            title: 'Autosomal dominant (AD)'/* ___ */,
            value: 'ad_cutoff',
            type: 'number',
            errorTitle: 'AD'/* ___ */,
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => '0.001'/* ___ */,
            outputFormat: value => value || 0.001,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: 'Autosomal recessive (AR)'/* ___ */,
            value: 'ar_cutoff',
            type: 'number',
            errorTitle: 'AR'/* ___ */,
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => '0.05'/* ___ */,
            outputFormat: value => value || 0.05,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: 'Compound heterozygosity'/* ___ */,
            value: 'comp_het_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => '0.05'/* ___ */,
            outputFormat: value => value || 0.05,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: 'Exclude LQ variants'/* ___ */,
            value: 'exclude_low_quality_variants',
            type: 'boolean',
            grid: 2,
            inputFormat: value => ![undefined, null].includes(value) ? value : false
          },
          {
            title: 'Lower priority for known benign variants'/* ___ */,
            value: 'enable_clinvar_benign_filter',
            type: 'boolean',
            grid: 2,
            inputFormat: value => ![undefined, null].includes(value) ? value : true
          },
          {}
        ],
        'field3_2': [
          {
            title: 'Phenotype score'/* ___ */,
            value: 'phenotype_score_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => '0.3'/* ___ */,
            outputFormat: value => (value || 0.3) - 0,
            validate: 'min_value:0|max_value:1'
          },
          {
            title: 'Variant score'/* ___ */,
            value: 'variant_score_cutoff',
            type: 'number',
            grid: 2,
            inputWidth: '126px',
            step: 0.01,
            placeholder: () => '0.7'/* ___ */,
            outputFormat: value => (value || 0.7) - 0,
            validate: 'min_value:0.6|max_value:1'
          },
          {}
        ],
        'field4': [
          {
            title: 'Pipeline'/* ___ */,
            errorTitle: 'Omics'/* ___ */,
            value: 'omics_name',
            type: 'select',
            grid: 1,
            options: this.omicsOptions,
            placeholder: () => 'Omics'/* ___ */,
            validate: Object.values(this.fileSets[0]).some(file => file) ? 'required' : ''
          },
          {
            title: '　'/* ___ */,
            errorTitle: 'Pipeline'/* ___ */,
            value: 'pipeline_name',
            type: 'select',
            grid: 2,
            options: this.pipelineOptions,
            placeholder: () => 'Types, eg: WGS'/* ___ */,
            display: result => result.omics_name,
            validate: Object.values(this.fileSets[0]).some(file => file) ? 'required' : ''
          },
          {
            title: '　'/* ___ */,
            errorTitle: 'Library type'/* ___ */,
            value: 'library_type_name',
            type: 'select',
            grid: 3,
            options: this.libraryTypeOptions,
            placeholder: () => 'Library kit eg: Roche KAPA HyperExome kit'/* ___ */,
            display: result => result.pipeline_name
          }
        ]
      }
    },
    // global
    priceMap () { return priceMap },
    fileTypeCheck () { return fileTypeCheck },
    // unload alert
    sendData () {
      let caseData = {
        dataset: this.dataset
      }
      let projectData = {}
      if (this.layoutBlocks.includes('form')) {
        caseData = {
          ...caseData,
          ...this.result['case'],
          affected: this.result['case'].affected || false
        }
        delete caseData.AFFECTED
        delete caseData.USER_ID
      }
      if (this.layoutBlocks.includes('analysis')) {
        // analysis
        projectData = {
          ...projectData,
          ...this.result['analysis'],
          report_phenovardb: this.result['analysis'].report_phenovardb || false
        }
        delete projectData.REPORT_PHENOVARDB
        // phenotype
        let selectedPhenotypes = [...this.selectedPhenotypes['panelPhenotypes'], ...this.selectedPhenotypes['phenotypes']]
        if (selectedPhenotypes.length) {
          let phenotypes = groupBy(groupBy(selectedPhenotypes, phenotype => phenotype.id).map(group => group[0]), phenotype => phenotype.type, true)
          phenotypes.hpo = phenotypes.hpo ? phenotypes.hpo.map(hpo => ({
            hpo_id: hpo.id,
            hpo_name: hpo.name,
            query: hpo.query
          })) : phenotypes.hpo
          phenotypes.disease_term = phenotypes.disease_term ? phenotypes.disease_term.map(disease => ({
            disease_id: disease.id,
            disease_name: disease.name,
            query: disease.query
          })) : phenotypes.disease_term
          projectData.phenotypes = phenotypes
        }
        // gene panel
        let selectedGenes = this.selectedPhenotypes['genes']
        if (selectedGenes.length) {
          let genePanels = []
          genePanels = selectedGenes.map(gene => ({
            name: gene.name,
            data: gene.data,
            category: gene.category
          }))
          projectData.gene_panels = genePanels
        }
      }
      caseData = {
        ...caseData,
        project: projectData
      }
      return caseData
    },
    sendFileSets () {
      let fileSets = {
        vcf: this.vcfSets.filter(set => set.vcf),
        fastq: this.fileSets.filter(set => set.r1 && set.r2)
      }[this.dataset]
      return fileSets
    }
  },
  watch: {
    'defaultData' () {
      this.init()
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    // unload alert
    'sendData' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.$emit('unloadAlert', true)
      }
    },
    'sendFileSets' (nv, ov) {
      if (JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.$emit('unloadAlert', true)
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setModal2Action',
      'setLoadingAction',
      'setUserSettingAction'
    ]),
    async preSetData () {
      this.init()
    },
    async fetchData () {
      if (['supervisor'].includes(this.user.role)) {
        await this.fetchCloudFilePaths()
      }
      if (['supervisor', 'manager'].includes(this.user.role) && ['create', 'edit'].includes(this.mode)) {
        await this.fetchManagedUsers()
      }
      await this.fetchOmicss()
      await this.fetchPhenotypePanels()
    },
    async fetchCloudFilePaths () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getCloudFilePaths(config)
        let cloudFilePaths = response.data.data
        this.cloudFilePaths = cloudFilePaths
      } catch (error) {
        throw error
      }
    },
    async fetchManagedUsers () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getManagedUsers(config)
        let users = response.data.data
        this.users = users
        this.caseData = {
          ...this.caseData,
          user_id: this.caseData.user ? this.caseData.user.id : users[0].id
        }
        this.result['case'].user_id = this.caseData.user_id
      } catch (error) {
        throw error
      }
    },
    async fetchOmicss () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getOmicss(config)
        let omicss = response.data.data
        this.omicss = omicss
      } catch (error) {
        throw error
      }
    },
    async fetchPhenotypePanels () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getPhenotypePanels(config)
        let phenotypePanels = response.data.data
        this.phenotypePanels = phenotypePanels.map(panel => ({
          ...panel,
          phenotypes: [
            ...panel.hpo.map(phenotype => ({
              id: phenotype.hpo_id,
              name: phenotype.hpo_name,
              query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
              panel: panel,
              type: 'hpo'
            })),
            ...panel.disease_term.map(phenotype => ({
              id: phenotype.disease_id,
              name: phenotype.disease_name,
              query: phenotype.disease_id + ' ' + phenotype.disease_name,
              panel: panel,
              type: 'disease_term'
            }))
          ]
        }))
      } catch (error) {
        throw error
      }
    },
    async fetchSubData (funcs, params = []) {
      funcs = funcs || [
        'fetchGenePanelDivisions',
        'fetchGenePanels'
      ]
      this.setLoadingAction(true)
      for (let [index, func] of Object.entries(funcs)) {
        try {
          await this[func](params[index] || params[0])
        } catch (error) {
          this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        }
      }
      this.setLoadingAction(false)
    },
    async fetchGenePanelDivisions () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getGenePanelDivisions(config)
        let divisions = response.data.data
        this.divisions = divisions
      } catch (error) {
        throw error
      }
    },
    async fetchGenePanels () {
      try {
        let config = this.$ls.get('userInfo')
        let params = {}
        let response = await getGenePanels(params, config)
        let genePanels = response.data.data
        genePanels = genePanels.map(panel => ({
          ...panel,
          count: [
            (panel.data['free_typing'] || []).length,
            (panel.data['user_defined'] || []).length,
            (panel.data['panel'] || []).reduce((s, panelData) => s + panelData.data.length, 0),
            (panel.data['hpo'] || []).reduce((s, panelData) => s + panelData.data.length, 0),
            (panel.data['condition'] || []).reduce((s, panelData) => s + panelData.data.length, 0)
          ].reduce((s, c) => s + c, 0)
        }))
        this.genePanels = genePanels
      } catch (error) {
        throw error
      }
    },
    async afterSetData () {
      setTimeout(() => this.$emit('unloadAlert', false))
    },
    init () {
      this.caseData = {
        ...this.caseData,
        ...(this.defaultData['case'] || {}),
        affected: ![null, undefined].includes(this.defaultData['case'].affected) ? this.defaultData['case'].affected : true
      }
      this.result['case'] = {
        ...this.result['case'],
        affected: this.caseData.affected
      }
      this.analysisData = {
        ...this.analysisData,
        ...(this.defaultData['analysis'] || {})
      }
      this.result['analysis'] = {
        ...this.result['analysis'],
        report_phenovardb: this.analysisData.report_phenovardb
      }
      this.analysisData.name = this.analysisData.name || ('Analysis-' + dateFormat(new Date(), 'yyyyMMdd'))
      this.initPhenotype()
    },
    initPhenotype (analysisData) {
      analysisData = analysisData || this.analysisData
      let phenotypes = this.analysisData.phenotypes ? [
        ...(this.analysisData.phenotypes.hpo || []).map(hpo => ({
          id: hpo.hpo_id,
          name: hpo.hpo_name,
          query: hpo.query,
          type: 'hpo'
        })),
        ...(this.analysisData.phenotypes.disease_term || []).map(disease => ({
          id: disease.disease_id,
          name: disease.disease_name,
          query: disease.query,
          type: 'disease_term'
        }))
      ] : []
      !this.searchedPhenotypes['phenotypes'].length && (this.searchedPhenotypes['phenotypes'] = [...(phenotypes || [])])
      !this.selectedPhenotypes['phenotypes'].length && (this.selectedPhenotypes['phenotypes'] = [...(phenotypes || [])])
      let genes = analysisData.gene_panels || []
      !this.searchedPhenotypes['genes'].length && (this.searchedPhenotypes['genes'] = [...(genes || [])])
      !this.selectedPhenotypes['genes'].length && (this.selectedPhenotypes['genes'] = [...(genes || [])])
    },
    async getPhenotypes (query) {
      if (!((this.tagData.tag['phenotypes'] || { datas: [] }).datas || []).includes(query)) {
        if (this.tagData.searchTimer['phenotype']) {
          clearTimeout(this.tagData.searchTimer['phenotype'])
        }
        this.tagData.searchTimer['phenotype'] = setTimeout(async () => {
          if (!this.tagData.map['phenotype'][query] && query) {
            try {
              let config = this.$ls.get('userInfo')
              let response = await getSearchPhenotype(query, config)
              let phenotypes = response.data.data
              this.tagData.map['phenotype'] = {
                ...this.tagData.map['phenotype'],
                [query]: {
                  info: phenotypes,
                  datas: [
                    ...phenotypes.hpo.data.map(data => ({ ...data, type: 'hpo' })),
                    ...phenotypes.disease_term.data.map(data => ({ ...data, type: 'disease_term' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
          }
          this.tagData.tag['phenotypes'] = this.tagData.map['phenotype'][query] || {}
        }, 200)
      }
    },
    async getGenes (query) {
      if ((this.tagData.curTag['gene'] || {}).name !== query) {
        this.tagData.tag['genes'] = {}
        if (this.tagData.searchTimer['gene']) {
          clearTimeout(this.tagData.searchTimer['gene'])
        }
        this.tagData.searchTimer['gene'] = setTimeout(async () => {
          if (!this.tagData.map['gene'][query] && query) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let response = await getSearchGeneEntry(query, config)
              let genes = response.data.data
              this.tagData.map['gene'] = {
                ...this.tagData.map['gene'],
                [query]: {
                  info: genes,
                  datas: [
                    ...genes.gene.data.map(data => ({ ...data, type: 'gene' })),
                    ...genes.panel.data.map(data => ({ ...data, type: 'panel' })),
                    ...genes.hpo.data.map(data => ({ ...data, type: 'hpo' })),
                    ...genes.condition.data.map(data => ({ ...data, type: 'condition' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
          this.tagData.tag['genes'] = this.tagData.map['gene'][query] || {}
        }, 500)
      }
    },
    async addToSearch (type, data) {
      switch (type) {
        case 'phenotype': {
          if (!(this.tagData.tag['phenotypes'].datas || []).some(tag => tag.query === this.tagData.query['phenotype'])) {
            data = this.tagData.tag['phenotypes'].datas[0].query
          }
          let ary = data.split(' ')
          let phenotypeID = ary.splice(0, 1)[0]
          let phenotypeName = ary.join(' ')
          let phenotypeType = phenotypeID.startsWith('HP:') ? 'hpo' : 'disease_term'
          let phenotype = {
            id: phenotypeID,
            name: phenotypeName,
            type: phenotypeType,
            query: phenotypeID + ' ' + phenotypeName
          }
          if (!this.searchedPhenotypes['phenotypes'].some(p => p.id === phenotype.id)) {
            this.searchedPhenotypes['phenotypes'].push(phenotype)
            if (!this.selectedLimit['phenotypes']) {
              this.selectedPhenotypes['phenotypes'].push(phenotype)
            }
          } else {
            this.addToast('error', 'You have added a HPO term with the same HPO identity.'/* ___ */)
          }
          this.tagData.query['phenotype'] = ''
          break
        }
        case 'gene': {
          data = data.type ? data : (this.tagData.map['gene'][this.tagData.query['gene']] || { datas: [] }).datas[0]
          if (data && !this.loading['addToSearch']) {
            this.loading['addToSearch'] = true
            switch (data.type) {
              case 'gene': {
                let symbols = await this.getGeneSymbols(data.type, data.gene_id)
                let gene = {
                  name: data.symbol,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(oldData)
                  }
                }
                break
              }
              case 'panel': {
                let panel = await this.getGenePanel(data.id)
                const symbolTransform = symbols => symbols.reduce((s, c) => ({ ...s, [c.gene_id]: c }), {})
                let symbols = Object.values({
                  ...symbolTransform(panel.data['free_typing'] || []),
                  ...symbolTransform(panel.data['user_defined'] || []),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['panel'] || []).map(panel => panel.data))),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['hpo'] || []).map(panel => panel.data))),
                  ...symbolTransform(Array.prototype.concat.apply([], (panel.data['condition'] || []).map(panel => panel.data)))
                }).filter(data => data.checked)
                let gene = {
                  name: panel.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else {
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(oldData)
                  }
                }
                break
              }
              case 'hpo': {
                let symbols = await this.getGeneSymbols(data.type, data.name)
                let gene = {
                  name: data.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(oldData)
                  }
                }
                break
              }
              case 'condition': {
                let symbols = await this.getGeneSymbols(data.type, data.name)
                let gene = {
                  name: data.name,
                  category: data.type,
                  data: symbols
                }
                let oldData = this.searchedPhenotypes['genes'].find(g => g.name === gene.name)
                if (!oldData) {
                  this.searchedPhenotypes['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(gene)
                  }
                } else if (oldData.checked === false) {
                  if (!this.selectedLimit['genes']) {
                    this.selectedPhenotypes['genes'].push(oldData)
                  }
                }
                break
              }
              default: {}
            }
            this.tagData.query['gene'] = ''
            this.loading['addToSearch'] = false
          }
          break
        }
        default: {}
      }
    },
    async getGeneSymbols (type, query) {
      try {
        let config = this.$ls.get('userInfo')
        let api = {
          gene: getGenePanelSymbol,
          hpo: getGenePanelHpo,
          condition: getGenePanelCondition
        }[type]
        let response = await api(query, config)
        let symbols = response.data.data
        symbols = symbols.map(symbol => ({
          ...symbol,
          checked: true,
          date: new Date()
        }))
        return symbols
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        return null
      }
    },
    async getGenePanel (id) {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getGenePanel(id, config)
        let panel = response.data.data
        return panel
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        return null
      }
    },
    addToPanel (phenotype) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'addToPanel',
        width: '468px',
        param: {
          phenotype: phenotype,
          panels: this.phenotypePanels
        },
        callback: async result => {
          if (result) {
            await this.fetchPhenotypePanels()
          }
        }
      })
    },
    openGenePanelDataSelect (data) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'genePanelDataSelect',
        width: '1208px',
        param: {
          data: data
        }
      })
    },
    async openGenePanelSearch () {
      if (!(this.genePanels.length && this.divisions.length)) {
        await this.fetchSubData()
      }
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'genePanelQuickSelection',
        width: '1208px',
        customStyles: {
          'max-height': 'calc(100% - 160px)'
        },
        param: {
          datas: this.genePanels,
          divisions: this.divisions
        },
        callback: async result => {
          if (result) {
            await this.addToSearch('gene', {
              type: 'panel',
              id: result - 0
            })
          }
        }
      })
    },
    onEvent (e, c) {
      if (['tag', 'send'].includes(e)) {
        if (c && c !== 'all') {
          let id = c.id || (this.users.find(user => c === [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : '')) || {}).id
          this.result['case'].user_id = id || this.result['case'].user_id
          this.caseData = {
            ...this.caseData,
            user_id: this.result['case'].user_id
          }
        } else {
          this.result['case'].user_id = -1
        }
      }
    },
    initFile () {
      this.vcfSets = [
        {
          vcf: null
        }
      ]
      this.fileSets = [
        {
          r1: null,
          r2: null
        }
      ]
    },
    selectFile (e, set, target) {
      set[target] = e.target.files[0]
    },
    openFileCloud (set, target) {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      let selectedPaths = Array.prototype.concat.apply([], (target === 'vcf' ? this.vcfSets : this.fileSets).map(set => Object.values(set).map(file => (file || {}).path).filter(x => x)))
      selectedPaths = selectedPaths.filter(path => path !== (set[target] || {}).path)
      action({
        action: 'fileCloud',
        width: '616px',
        param: {
          type: 'single',
          options: {
            checkbox: false
          },
          fileTypes: ['fastq', 'fq', 'fastq.gz', 'fq.gz'],
          paths: this.cloudFilePaths,
          currentPath: set[target] ? set[target].path : this.cloudFileCurrentPath || this.userSetting.cloudspace_browse_path || '',
          disabledPaths: selectedPaths,
          defaultSelectedPaths: set[target] ? [set[target].path] : [],
          functions: {
            saveCurrentPath: path => this.saveCurrentPath(path)
          }
        },
        callback: async result => {
          if (result) {
            let path = result[0]
            const contentTypeMap = {
              gz: 'application/x-gzip',
              vcf: 'text/directory'
            }
            set[target] = {
              name: path.split('/').reverse()[0],
              type: contentTypeMap[path.split('.').reverse(0)[0]] || 'text/plain',
              path: path
            }
          }
        }
      })
    },
    async saveCurrentPath (path) {
      try {
        let config = this.$ls.get('userInfo')
        let folderPath = path.replace(/\/(?!.*\/).*$/, '')
        let data = {
          cloudspace_browse_path: folderPath
        }
        let response = await putUserSettings(data, config)
        let userSettings = response.data.data
        this.cloudFileCurrentPath = response.data.data.cloudspace_browse_path
        this.setUserSettingAction(userSettings)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    formOnChange (key, field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result[key] = {
        ...this.result[key],
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.caseData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    fileValidate () {
      if (Object.values(this.fileSets[this.fileSets.length - 1]).filter(file => file).length !== 1) {
        return true
      } else {
        this.addToast('error', 'The data should be paired, please check you file numbers.'/* ___ */)
        return false
      }
    },
    async validateSubmit () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['file'] = !this.layoutBlocks.includes('file') || this.fileValidate()
      if (!Object.values(result).includes(false)) {
        return true
      }
      this.onSubmit = false
    },
    async submit () {
      let data = this.sendData
      let fileSets = this.sendFileSets
      return { data: data, fileSets: fileSets, users: this.users }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/base.vue